module.exports = __webpack_public_path__ + "media/images/gastrozabota_template-734ebf10820a91e9465e7d2874cebdd7.png";